// SLY cart drawer + quick view, on Shopify's own Cart AJAX API (no apps).
// SLYCart.add([{ id, quantity }]) adds variants and opens the drawer. Settings come from the "SLY · Cart drawer" section.
(function () {
  const root = document.querySelector('[data-sly-cart-root]');
  if (!root) return;
  const cfg = JSON.parse(root.querySelector('[data-sly-cart-config]').textContent);
  const dlg = root.querySelector('dialog.sly-cart');
  const qvDlg = root.querySelector('dialog.sly-qv');
  const esc = s => String(s ?? '').replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
  const money = cents => `<span class="sly-cur">${cfg.currency}</span> <span class=money>${(cents / 100).toFixed(cfg.decimals)}</span>`;  // span.money: see sly-money.liquid
  const img = (src, w) => src ? src.replace(/^\/\//, 'https://').replace(/(\.[a-z]+)(\?|$)/i, `_${w}x$1$2`) : '';
  const TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>';
  let cart = null, codeError = '', recs = [], recsFor = null, sideOpen = false, notice = '';
  // pre-order guard: variant id -> launch time (unix seconds) for products not launched yet
  const pre = cfg.prelaunch || {};
  const locked = id => (pre[id] || 0) * 1000 > Date.now();
  const when = ts => new Date(ts * 1000).toLocaleString(undefined, { month: 'long', day: 'numeric', hour: 'numeric', minute: '2-digit' });
  const wide = matchMedia('(min-width: 1024px)');

  const api = (url, body) => fetch(url, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } })
    .then(async r => { const j = await r.json(); if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong'); return j; });

  function badge() {
    document.querySelectorAll('[data-sly-cart-count]').forEach(b => { b.textContent = cart.item_count; b.classList.toggle('on', cart.item_count > 0); });
  }

  function sug(p) {
    return `<li class="ct-sug"><a href="${esc(p.url)}"><span class="ct-pic"><img src="${esc(p.image)}" alt="" loading="lazy"></span><b>${esc(p.title)}</b><span>${money(p.price)}</span></a>
      <button type="button" data-cart-add="${p.variant}" aria-label="Add ${esc(p.title)}">+</button></li>`;
  }

  // second pane: Shopify's own recommendations for the first item in the cart, then the editor's picks
  async function loadRecs() {
    const id = cart.items[0]?.product_id;
    if (!id || id === recsFor) return;
    recsFor = id;
    const get = intent => fetch(`${cfg.recs_url}?product_id=${id}&limit=8&intent=${intent}`).then(r => r.ok ? r.json() : { products: [] }).then(j => j.products || []).catch(() => []);
    let list = await get('complementary');
    if (list.length < 3) list = list.concat(await get('related'));
    recs = list.filter(p => p.available).map(p => ({ product: p.id, variant: (p.variants.find(v => v.available) || p.variants[0]).id, title: p.title, price: p.price, url: p.url, image: img(p.featured_image, 300) }));
    if (dlg.open) draw();
  }

  function draw() {
    const sub = cart.items_subtotal_price, total = cart.total_price, off = cart.total_discount;
    const free = cfg.free_at * 100, left = Math.max(0, free - sub), pct = Math.min(100, free ? sub / free * 100 : 100);
    const inCart = new Set(cart.items.map(i => i.product_id));
    const seen = new Set();
    const sugs = recs.concat(cfg.suggestions).filter(p => !inCart.has(p.product) && !locked(p.variant) && !seen.has(p.product) && seen.add(p.product)).slice(0, cart.items.length ? 6 : 3);
    dlg.classList.toggle('ct-wide', cart.items.length > 0 && sugs.length > 0);
    const codes = (cart.discount_codes || []).filter(c => c.applicable);
    dlg.innerHTML = `
      <header class="ct-head"><h2>${esc(cfg.heading)} <span class="ct-n">${cart.item_count}</span></h2><button class="ct-x" type="button" data-cart-close aria-label="Close cart">×</button></header>
      ${cart.items.length ? `
      <div class="ct-body"><div class="ct-main">
      ${notice ? `<p class="ct-notice" role="status">${esc(notice)}</p>` : ''}
      ${free ? `<div class="ct-ship ${left ? '' : 'done'}">
        <p>${left ? cfg.ship_left.replace('[amount]', `<b>${money(left)}</b>`) : `<b>${esc(cfg.ship_done)}</b>`}</p>
        <div class="ct-bar" role="progressbar" aria-valuemin="0" aria-valuemax="${free}" aria-valuenow="${Math.min(sub, free)}" aria-label="Progress to free delivery"><i style="width:${pct}%"><span>${TRUCK}</span></i></div>
      </div>` : ''}
      <ul class="ct-lines">${cart.items.map((it, i) => `<li class="ct-line" data-key="${esc(it.key)}">
        <a class="ct-pic" href="${esc(it.url)}"><img src="${esc(img(it.image, 240))}" alt=""></a>
        <div class="ct-info"><a href="${esc(it.url)}"><b>${esc(it.product_title)}</b></a>${it.product_has_only_default_variant ? '' : `<small>${esc(it.variant_title)}</small>`}<span class="ct-each">${money(it.final_price)}</span>
          <div class="ct-row"><div class="ct-qty"><button type="button" data-q="${esc(it.key)}" data-n="${it.quantity - 1}" aria-label="One less ${esc(it.product_title)}">−</button><span aria-live="polite">${it.quantity}</span><button type="button" data-q="${esc(it.key)}" data-n="${it.quantity + 1}" aria-label="One more ${esc(it.product_title)}">+</button></div>
          <button class="ct-rm" type="button" data-q="${esc(it.key)}" data-n="0">Remove</button></div></div>
        <b class="ct-sum">${money(it.final_line_price)}</b></li>`).join('')}</ul>
      </div>
      ${sugs.length ? `<aside class="ct-side"><details ${wide.matches || sideOpen ? 'open' : ''} data-side><summary><span class="sly-note">${esc(cfg.suggest_note)}</span><b>${esc(cfg.suggest_heading)}</b></summary><ul>${sugs.map(sug).join('')}</ul></details></aside>` : ''}
      <footer class="ct-foot">
        ${cfg.show_code ? `<details class="ct-code" ${codes.length || codeError ? 'open' : ''}><summary>Have a discount code?</summary>
          ${codes.map(c => `<p class="ct-applied"><span>${esc(c.code)}</span> applied <button type="button" data-code-rm>Remove</button></p>`).join('')}
          ${codes.length ? '' : `<form class="ct-form" data-code-form><input name="code" placeholder="Enter code" aria-label="Discount code" autocomplete="off"><button>Apply</button></form><p class="ct-err" role="alert">${esc(codeError)}</p>`}
        </details>` : ''}
        <dl class="ct-tot"><div><dt>Subtotal</dt><dd>${money(sub)}</dd></div>
          ${off ? `<div class="ct-off"><dt>Discount</dt><dd>−${money(off)}</dd></div>` : ''}
          <div><dt>Delivery</dt><dd>${free && !left ? 'Free' : 'At checkout'}</dd></div>
          <div class="ct-grand"><dt>Total</dt><dd>${money(total)}</dd></div></dl>
        <a class="ct-go" href="${cfg.checkout_url}">${esc(cfg.checkout_label)} · ${money(total)}</a>
        <div class="ct-pay">${cfg.payment_icons}</div>
      </footer></div>` : `
      <div class="ct-empty"><span class="sly-note">${esc(cfg.empty_note)}</span><p>Your cart is empty.</p><a class="ct-go" href="${cfg.empty_link}">${esc(cfg.empty_label)}</a></div>
      ${sugs.length ? `<section class="ct-more"><h3>${esc(cfg.suggest_heading)}</h3><ul>${sugs.map(sug).join('')}</ul></section>` : ''}`}`;
    badge();
  }

  const refresh = () => api('/cart.js').then(async c => {
    // take out anything that isn't launched yet (e.g. added through an old link)
    const early = c.items.filter(i => locked(i.variant_id));
    if (early.length) {
      const updates = Object.fromEntries(early.map(i => [i.key, 0]));
      c = await api('/cart/update.js', { updates });
      notice = `${early.map(i => i.product_title).join(', ')} ${early.length > 1 ? 'are' : 'is'} not out yet, so we took it out of your bag. It drops ${when(pre[early[0].variant_id])}.`;
    }
    cart = c; draw(); notice = ''; loadRecs();
  });
  const open = () => refresh().then(() => { if (!dlg.open) dlg.showModal(); });

  async function add(items) {
    const blocked = items.filter(i => locked(i.id));
    items = items.filter(i => !locked(i.id));
    if (blocked.length) (window.toast || alert)(`Not out yet. It drops ${when(pre[blocked[0].id])}.`);
    if (!items.length) return;
    try { await api('/cart/add.js', { items }); }
    catch (e) { (window.toast || alert)(e.message); return; }
    if (qvDlg.open) qvDlg.close();
    await open();
    const ids = new Set(items.map(i => +i.id));
    const row = [...dlg.querySelectorAll('.ct-line')].find(r => ids.has(+cart.items.find(i => i.key === r.dataset.key)?.variant_id));
    if (row) { row.classList.add('ct-new'); row.scrollIntoView({ block: 'nearest' }); }
  }

  dlg.addEventListener('click', e => {
    const t = e.target;
    if (t === dlg || t.closest('[data-cart-close]')) return dlg.close();
    const q = t.closest('[data-q]');
    if (q) return api('/cart/change.js', { id: q.dataset.q, quantity: +q.dataset.n }).then(c => { cart = c; draw(); loadRecs(); });
    const a = t.closest('[data-cart-add]');
    if (a) return add([{ id: +a.dataset.cartAdd, quantity: 1 }]);
    if (t.closest('[data-code-rm]')) return api('/cart/update.js', { discount: '' }).then(c => { cart = c; codeError = ''; draw(); });
  });
  dlg.addEventListener('toggle', e => { if (e.target.matches('[data-side]') && !wide.matches) sideOpen = e.target.open; }, true);
  dlg.addEventListener('submit', e => {
    if (!e.target.matches('[data-code-form]')) return;
    e.preventDefault();
    const code = e.target.code.value.trim();
    if (!code) { codeError = 'Enter a code first.'; return draw(); }
    api('/cart/update.js', { discount: code }).then(c => {
      cart = c;
      const hit = (c.discount_codes || []).find(d => d.code.toLowerCase() === code.toLowerCase());
      codeError = hit && hit.applicable ? '' : `“${code}” can't be used on this cart. Check the code and what's in your bag.`;
      if (hit && !hit.applicable) api('/cart/update.js', { discount: '' }).then(c2 => { cart = c2; draw(); }); else draw();
    });
  });

  // quick view
  async function quickView(handle, launchTs = 0) {
    const p = await api(`/products/${encodeURIComponent(handle)}.js`);
    let variant = p.variants.find(v => v.available) || p.variants[0], qty = 1;
    const opts = p.options.filter(o => !(p.options.length === 1 && o.values.length === 1 && o.values[0] === 'Default Title'));
    const pick = () => p.variants.find(v => v.options.every((val, i) => val === sel[i]));
    const sel = [...variant.options];
    const media = (p.media || []).filter(m => m.media_type === 'image').map(m => m.src);
    const render = () => {
      variant = pick() || variant;
      qvDlg.innerHTML = `<div class="qv-in">
        <div class="qv-media">${media.length > 1 ? `<div class="qv-thumbs">${media.map((s, i) => `<button type="button" aria-current="${i === 0}" data-src="${esc(img(s, 900))}"><img src="${esc(img(s, 160))}" alt=""></button>`).join('')}</div>` : ''}
          <div class="qv-main"><img src="${esc(img(variant.featured_image?.src || media[0], 900))}" alt="${esc(p.title)}"></div></div>
        <div class="qv-body"><h3>${esc(p.title)}</h3>
          <div class="qv-price">${money(variant.price)}${variant.compare_at_price > variant.price ? `<s>${money(variant.compare_at_price)}</s>` : ''}</div>
          ${opts.map(o => `<fieldset class="sly-pd__opt"><legend>${esc(o.name)}: <span>${esc(sel[o.position - 1])}</span></legend><div class="sly-pd__chips">${o.values.map(v => {
            const test = [...sel]; test[o.position - 1] = v; const tv = p.variants.find(x => x.options.every((val, i) => val === test[i]));
            return `<button type="button" data-opt="${o.position - 1}" data-val="${esc(v)}" aria-pressed="${sel[o.position - 1] === v}"${tv && tv.available ? '' : ' class="is-out"'}>${esc(v)}</button>`; }).join('')}</div></fieldset>`).join('')}
          <p class="qv-blurb">${esc((p.description || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim().split(/(?<=[.!?])\s/).slice(0, 2).join(' '))}</p>
          <div class="sly-pd__row qv-buy"><div class="sly-pd__qty"><button type="button" data-qq="-1" aria-label="Less">−</button><span>${qty}</span><button type="button" data-qq="1" aria-label="More">+</button></div>
            ${launchTs * 1000 > Date.now() || locked(variant.id) ? `<button class="sly-btn sly-pd__add" type="button" disabled>Drops ${esc(when(launchTs || pre[variant.id]))}</button>` : `<button class="sly-btn sly-pd__add" type="button" data-qv-add ${variant.available ? '' : 'disabled'}>${variant.available ? 'Add to bag' : 'Sold out'}</button>`}</div>
          <a class="qv-link" href="${esc(p.url)}">View full details</a>
        </div></div><button class="qv-close" type="button" aria-label="Close">×</button>`;
    };
    qvDlg.onclick = e => {
      if (e.target === qvDlg || e.target.closest('.qv-close')) return qvDlg.close();
      const th = e.target.closest('.qv-thumbs button');
      if (th) { qvDlg.querySelector('.qv-main img').src = th.dataset.src; qvDlg.querySelectorAll('.qv-thumbs button').forEach(b => b.setAttribute('aria-current', b === th)); return; }
      const o = e.target.closest('[data-opt]');
      if (o) { sel[+o.dataset.opt] = o.dataset.val; return render(); }
      const qq = e.target.closest('[data-qq]');
      if (qq) { qty = Math.max(1, qty + +qq.dataset.qq); qvDlg.querySelector('.sly-pd__qty span').textContent = qty; return; }
      if (e.target.closest('[data-qv-add]')) add([{ id: variant.id, quantity: qty }]);
    };
    render();
    qvDlg.showModal();
  }

  document.addEventListener('click', e => {
    const opener = e.target.closest('[data-sly-cart-open]');
    if (opener) { e.preventDefault(); return open(); }
    const a = e.target.closest('[data-sly-add]');
    if (a) { e.preventDefault(); return add([{ id: +a.dataset.slyAdd, quantity: +(a.dataset.qty || 1) }]); }
    const q = e.target.closest('[data-sly-qv]');
    if (q) { e.preventDefault(); return quickView(q.dataset.slyQv, +(q.dataset.launch || 0)); }
  });

  window.SLYCart = { add, open, quickView, money, refresh };
})();
